import React, { useEffect } from 'react';
import classNames from 'classnames';
import styles from './Toast.module.scss';
import { useAppDispatch, useAppSelector } from '../../../store';
import { hideToast } from '../../../store/slices/uiSlice';
import CloseIcon from '../../../assets/icons/close.svg';
import SuccessIcon from '../../../assets/icons/checkOutlined.svg';
import ErrorIcon from '../../../assets/icons/errorIcon.svg';
import RobotIcon from '../../../assets/icons/robbot.svg';
import { ToastType } from '../../../types';

const iconMap: Record<ToastType, string> = {
  success: SuccessIcon,
  error: ErrorIcon,
  robotik: RobotIcon,
};

const Toast: React.FC = () => {
  const dispatch = useAppDispatch();
  const toast = useAppSelector((state) => state.ui.toast);

  useEffect(() => {
    if (toast) {
      const timer = setTimeout(() => {
        dispatch(hideToast());
      }, toast.timeout || 5000);

      return () => clearTimeout(timer);
    }
  }, [toast, dispatch]);

  if (!toast) return null;

  return (
    <div className={classNames(styles.toast, styles[toast.type])}>
      <img src={iconMap[toast.type]} alt={toast.type} className={styles.icon} />
      <div className={styles.content}>
        {toast.title && <span className={styles.title}>{toast.title}</span>}
        {toast.body && <span className={styles.body}>{toast.body}</span>}
      </div>
      <button className={styles.closeButton} onClick={() => dispatch(hideToast())}>
        <img src={CloseIcon} alt="Close" />
      </button>
    </div>
  );
};

export default Toast;
